import { useState } from "react";
import { CircleAlert, CircleCheck, KeyRound } from "lucide-react";
import { post } from "../api";

const MIN_LENGTH = 8;

export default function ResetPassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword.length < MIN_LENGTH) {
      setError(`رمز عبور جدید باید حداقل ${MIN_LENGTH} کاراکتر باشد.`);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("رمز عبور جدید و تکرار آن یکسان نیستند.");
      return;
    }

    setSubmitting(true);
    try {
      await post("/api/auth/reset-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });
      setSuccess("رمز عبور با موفقیت تغییر کرد.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="page-head">
        <h1>تغییر رمز عبور</h1>
        <p>برای تغییر رمز عبور، ابتدا رمز فعلی خود را وارد کنید.</p>
      </div>

      <div className="card form-card">
        {error && (
          <div className="alert alert-error">
            <CircleAlert size={17} strokeWidth={2} aria-hidden="true" />
            {error}
          </div>
        )}
        {success && (
          <div className="alert alert-success">
            <CircleCheck size={17} strokeWidth={2} aria-hidden="true" />
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label htmlFor="current-password">رمز عبور فعلی</label>
            <input
              id="current-password"
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label htmlFor="new-password">رمز عبور جدید</label>
            <input
              id="new-password"
              type="password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span className="hint">حداقل {MIN_LENGTH} کاراکتر.</span>
          </div>

          <div className="field">
            <label htmlFor="confirm-password">تکرار رمز عبور جدید</label>
            <input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? (
              "در حال ذخیره…"
            ) : (
              <>
                <KeyRound size={18} strokeWidth={2} aria-hidden="true" />
                ذخیره رمز جدید
              </>
            )}
          </button>
        </form>
      </div>
    </>
  );
}
